import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Grid, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Brief from './Brief';
import ClaimHeader from '../../ExternalClaimsView/claim-header';

const useStyles = makeStyles(() => ({
  root: {}
}));

function Overview({ claimParts, claimInformation, claimNotes, dealerInformation, claimContactInformation, updateClaim, isGlassProcessor, user, className, handleSaveNote, handleUpdateClaimNote, handleDeleteClaimNote, ...rest }) {
  const classes = useStyles();

  return (

    <Grid container spacing={2} >
      <Grid item xs={12}>
        <ClaimHeader
          dealerInfo={dealerInformation}
          claimContactInfo={claimContactInformation}
          orderInfo={claimInformation}
          claimInfo={claimInformation}
        />
      </Grid>
      <Grid item xs={12}>
        <Brief claimParts={claimParts}
          claimInformation={claimInformation}
          updateClaim
          isGlassProcessor={isGlassProcessor}
          user={user}
          handleSaveNote={handleSaveNote}
          handleDeleteClaimNote={handleDeleteClaimNote}
          handleUpdateClaimNote={handleUpdateClaimNote}
          claimNotes={claimNotes} />
      </Grid>
    </Grid>
  );
}

Overview.propTypes = {
  className: PropTypes.string,
  claimParts: PropTypes.array,
  claimInformation: PropTypes.object,
  claimNotes: PropTypes.array,
  dealerInformation: PropTypes.object,
  claimContactInformation: PropTypes.object,
  updateClaim: PropTypes.func,
  isGlassProcessor: PropTypes.bool,
  user: PropTypes.object,
  handleSaveNote: PropTypes.func,
  handleUpdateClaimNote: PropTypes.func,
  handleDeleteClaimNote: PropTypes.func
};

export default Overview;
